<template>
  <div class="tab tab-informations">
    <h4>Informations essentielles</h4>
    <div class="inputs-container">
      <InputCopy label="Date de finalisation du test" :value="creation_time" />
      <InputCopy
        :label="$t('form.email')"
        :value="currentCandidate.candidate.email"
      />
      <InputCopy
        :label="$t('form.register.phone')"
        :value="currentCandidate.candidate.phone_number"
      />
    </div>
  </div>
</template>

<script setup>
import { inject, computed } from "vue";

const props = defineProps({
  currentCandidate: {
    type: Object,
    required: true,
  },
});

const moment = inject("moment");

const creation_time = computed(() => {
  return `Le ${moment(props.currentCandidate.results.creation_time).format(
    "DD MMMM YYYY à HH:mm"
  )}`;
});
</script>
